// Module
var code = `<div appHeaderBar><header-bar-title>Terms and Conditions</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container">
        <div class="HOA-container__header">
            <h1 class="HOA-container__header-text">Terms and Conditions</h1>
        </div>
        <div class="HOA-container__content HOA-container__content--legal HOA-content-font-18"
             [innerHTML]="terms | inAppBrowserLink">
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;